import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import VueProgressBar from 'vue-progressbar'
import App from './App.vue' //최초 진입점
import { router } from './routes/index.js' //vue-router
import { store } from './store/index.js' //vuex
import ApiUtil from './api/api.util' //Etners API Util
import ErrorFilter from './common/error.filter' //Error Filter(vue)
import VeeValidate from 'vee-validate' // validation library
import ko from 'vee-validate/dist/locale/ko.js'
import VueI18n from 'vue-i18n'
/* EBMP main css Import */
import './assets/css/font.css'
import './assets/css/main.css'

/* Kendo UI Style Import */
import '@progress/kendo-ui'
import './assets/kendo-theme/all.css'

/* Kendo Wrapper Grid */
import { Grid, GridInstaller } from '@progress/kendo-grid-vue-wrapper'

/* Kendo UI Dialog */
import {
  Dialog,
  DialogInstaller,
} from '@progress/kendo-dialog-vue-wrapper'

/* Kendo Dropdowns */
import {
  AutoComplete,
  ComboBox,
  DropDownList,
  MultiSelect,
  MultiColumnComboBox,
  MultiColumnComboBoxColumn,
  DropdownsInstaller,
} from '@progress/kendo-dropdowns-vue-wrapper'

/* Kendo Date-Picker */
import {
  Calendar,
  DateInput,
  DatePicker,
  DateRangePicker,
  DateTimePicker,
  MultiViewCalendar,
  TimePicker,
  DateinputsInstaller,
} from '@progress/kendo-dateinputs-vue-wrapper'

/* Kendo Inputs */
import {
  MaskedTextBox,
  NumericTextBox,
  ColorPicker,
  Slider,
  RangeSlider,
  Switch as KendoSwitch,
  InputsInstaller,
} from '@progress/kendo-inputs-vue-wrapper'

import { Upload, UploadInstaller } from '@progress/kendo-upload-vue-wrapper'

Vue.use(UploadInstaller)

import { LayoutInstaller } from '@progress/kendo-layout-vue-wrapper'

/* Kendo Editor */
import { Editor, EditorTool, EditorInstaller } from '@progress/kendo-editor-vue-wrapper'

/* Kendo Button */

import {
  Button,
  ButtonGroup,
  ButtonGroupButton,
  ToolBar,
  ToolBarItem,
  ButtonsInstaller,
} from '@progress/kendo-buttons-vue-wrapper'

/* Kendo Window */
import { Window, WindowInstaller } from '@progress/kendo-window-vue-wrapper'

/* Kendo TreeView */
import { TreeView, TreeViewItem, TreeViewInstaller } from '@progress/kendo-treeview-vue-wrapper';

/* Kendo TreeList */
import { TreeList, TreeListInstaller } from '@progress/kendo-treelist-vue-wrapper'

/* xlsx */
import * as XLSX from "xlsx";

/* Kendo Listbox */
import { ListBox, ListBoxInstaller } from '@progress/kendo-listbox-vue-wrapper'

import { Validator, ValidatorInstaller } from '@progress/kendo-validator-vue-wrapper'

/* Kendo Chart */
import { Chart,
        ChartSeriesItem,
        Sparkline,
        SparklineSeriesItem,
        StockChart,
        ChartInstaller } from '@progress/kendo-charts-vue-wrapper'

Vue.use(DialogInstaller)
Vue.use(VueLocalStorage)
Vue.use(DropdownsInstaller)
Vue.use(LayoutInstaller)
Vue.use(DateinputsInstaller)
Vue.use(InputsInstaller)
Vue.use(EditorInstaller)
Vue.use(ButtonsInstaller)
Vue.use(GridInstaller)
Vue.use(WindowInstaller)
Vue.use(TreeViewInstaller)
Vue.use(TreeListInstaller)
Vue.use(XLSX)
Vue.use(ListBoxInstaller)
Vue.use(ValidatorInstaller)

Vue.use(ChartInstaller)

const config = {
  locale    : 'ko',
  dictionary: {
    ko,
  },
}

Vue.use(VeeValidate, config)
Vue.use(VueI18n)
import { Validator as VeeValidator } from 'vee-validate'

const dictionary = {
  ko: {
    attributes: {
      email    : '이메일 ',
      id       : '아이디',
      password : '비밀번호 ',
      name     : '이름',
      birthDate: '생년월일',
    },
  },
}

VeeValidator.localize('ko', dictionary.ko)
VeeValidator.extend('password', {
  getMessage: `8~20글자 영문, 숫자, 특수문자 조합으로 작성해주세요`,
  validate  : value => {
    return /(?=.*\d{1,50})(?=.*[~`!@#$%\^&*()-+=]{1,50})(?=.*[a-zA-Z]{2,50}).{8,50}$/.test(value)
  },
})
VeeValidator.extend('password_continuity', {
  getMessage: field => `연속된 숫자, 문자가 3자리 이상 중복되면 안됩니다.`,
  validate  : value => { return chkContStr(value)},
})
VeeValidator.extend('password_id_same_three_char', {
  getMessage: field => `아이디와 3자 이상 중복되면 안됩니다.`,
  validate  : value => { return chkContStr(value)},
})

const chkContStr = function (str) {
  let cnt = 0
  let cnt2 = 0
  let tmp = ''
  let tmp2 = ''
  let tmp3 = ''

  for (let i = 0; i < str.length; i++) {

    tmp = str.charAt(i)
    tmp2 = str.charAt(i + 1)
    tmp3 = str.charAt(i + 2)

    if (tmp.charCodeAt(0) - tmp2.charCodeAt(0) === 1 && tmp2.charCodeAt(0) - tmp3.charCodeAt(0) === 1) {
      cnt = cnt + 1
    }
    if (tmp.charCodeAt(0) - tmp2.charCodeAt(0) === -1 && tmp2.charCodeAt(0) - tmp3.charCodeAt(0) === -1) {
      cnt2 = cnt2 + 1
    }
  }

  return !(cnt >= 1 || cnt2 >= 1)
}

/* ProgressBar */
const options = {
  color: '#fe5f40',
  failedColor: '#bffaf3',
  thickness: '3px',
  transition: {
    speed: '0.3s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  inverse: false
}
Vue.use(VueProgressBar, options)


/* Kendo DataSource */
import {
  DataSource,
  DataSourceInstaller,
} from '@progress/kendo-datasource-vue-wrapper'
import ApiConfig from './api/api.config'

Vue.use(DataSourceInstaller)

/* Vue Setting */
Vue.config.productionTip = false
Vue.filter('error', ErrorFilter)

ApiUtil.init()

new Vue({
  data      : {
    messages: [],
  },
  i18n      : new VueI18n({
    locale        : 'ko', // 기본언어는 ko로 유지하지만 브라우저 언어를 체크해서 변경
    fallbackLocale: 'ko',
    messages      : [],
  }),
  beforeCreate () {
    this.$store.dispatch('FETCH_URL')
    const vm = this
    if(sessionStorage.getItem('messages') === null || sessionStorage.getItem('messages') === undefined){
      ApiUtil.post(`${ApiConfig.singleDomain}/v1/ebmp/code/message.json`).then(response => {
        const parsedMessage = JSON.stringify(response.data)
        sessionStorage.setItem('messages', parsedMessage)
        const localeArray = ['ko', 'en', 'zh', 'vn', 'ja']
        localeArray.forEach(function (locale) {
          const msg = response.data[locale]
          vm.$i18n.setLocaleMessage(locale, msg)
        })
      })
    }

  },
  router,
  store,
  render    : h => h(App),
  components: {
    DataSource,
    DataSourceInstaller,
    Dialog,
    Grid,

    /* Date-Picker */
    Calendar,
    DateInput,
    DatePicker,
    DateRangePicker,
    DateTimePicker,
    MultiViewCalendar,
    TimePicker,

    /* Inputs */
    MaskedTextBox,
    NumericTextBox,
    ColorPicker,
    Slider,
    RangeSlider,
    KendoSwitch,

    /* Editor */
    Editor,

    /* Button */
    Button,
    ButtonGroup,
    ButtonGroupButton,
    ToolBar,
    ToolBarItem,
    Upload,

    /* ListBox */
    ListBox,

    /* TreeList */
    TreeList,

    Validator,

    /* Chart */
    Chart,
    Sparkline,
    StockChart,
  },
}).$mount('#app')
